<template>
  <!-- eslint-disable -->
  <Form action="Tambah" :noReferensiVal="noReferensi" />
</template>

<script>
import Form from "./Form.vue";
const moment = require("moment");

export default {
  data() {
    return {
      noReferensi: moment().format("YYYYMMDDHHmmss"),
    };
  },
  components: {
    Form,
  },
  props: ["id"],
};
</script>